import React, { FC } from 'react';
import { useConversation } from './hooks/useConversation';
import { ConversationRun } from './ConversationMessage';
import { AssistantChatInput } from './uiManager/assistant-chat-input/AssistantChatInput';
import { ConversationStatus, IConversation } from '../model/Conversation';
import styles from './conversation-view.module.scss';
import { Divider } from '@placer-ui/components';

export interface ConversationViewProps {
    conversation: IConversation;
}

export const ConversationView: FC<ConversationViewProps> = (props) => {
    const { conversation } = props;
    const { runs, postUserMessage, status } = useConversation(conversation);

    const enabled = status === ConversationStatus.Idle;

    return (
        <div data-testid="conversation-view" className={styles.conversationPanel}>
            <div className={styles.messages}>
                {runs.map((run, index) => {
                    return <ConversationRun run={run} key={run.getId()} isLastRun={index === runs.length - 1} />;
                })}
            </div>
            <Divider />
            <div className={styles.assistantChatInput}>
                <AssistantChatInput
                    canSubmit={enabled}
                    onSubmit={postUserMessage}
                    editorContentClassName={styles.editorContentClassName}
                />
            </div>
        </div>
    );
};
